import React from 'react';
import FaqTextContent from './FaqTextContent';

const FaqPanelBody = ({ content }) => (
  <div className="mini-faq__panel--body mini-faq__panel--body--nyc">
    <FaqTextContent content={content} />
  </div>
);

export default FaqPanelBody;



// WEBPACK FOOTER //
// ./src/components/Static/SFFleets/Shared/FaqPanelBody.js